<template>
  <div class="container">
    
    <div class="logisticstop">
        {{ content }}
    </div>
  </div>
</template>

<script>
import { selectVirtuallyExpress } from "@/api/api";
export default {
  data() {
    return {
      orderNo: "",
      content:''
    };
  },

  methods: {
    //获取短信
    async getLogistics(orderNo) {
      const res = await selectVirtuallyExpress({ orderNo: orderNo });
      if (res.code == "0000") {
        this.content = res.data.content;
      } else {
        this.$toast(res.msg);
      }
    },
  },
  mounted() {
    // 获取订单页面传来的订单信息,请求对应的物流数据
    this.orderNo = this.$route.query.orderNo;
    this.getLogistics(this.orderNo);
  },
};
</script>

<style lang="scss" scoped>

.container {
    padding-top: 10px;
  .logisticstop {
    margin: 20px auto;
    padding: 20px;
    width: 92%;
    background: #ffffff;
  }
}
.noinfo {
  text-align: center;
  font-size: 28px;
  padding: 20px;
}
</style>
